import { useAppSelector } from "./useApp"
import {
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
  getUserPermissions,
} from "helpers/permissions"

/**
 * Custom hook for checking user permissions
 * @returns Object containing permission checking functions
 */
export const usePermissions = () => {
  const userInfo = useAppSelector((state) => state.userInfo)

  return {
    /**
     * Check if user has a specific permission
     * @param permissionKey - Permission key to check
     * @returns true if user has permission, false otherwise
     */
    hasPermission: (permissionKey: string) =>
      hasPermission(userInfo, permissionKey),

    /**
     * Check if user has any of the specified permissions
     * @param permissionKeys - Array of permission keys to check
     * @returns true if user has at least one permission, false otherwise
     */
    hasAnyPermission: (permissionKeys: string[]) =>
      hasAnyPermission(userInfo, permissionKeys),

    /**
     * Check if user has all of the specified permissions
     * @param permissionKeys - Array of permission keys to check
     * @returns true if user has all permissions, false if missing any permission
     */
    hasAllPermissions: (permissionKeys: string[]) =>
      hasAllPermissions(userInfo, permissionKeys),

    /**
     * Get all user permissions
     * @returns Array of permissions or empty array if none
     */
    getUserPermissions: () => getUserPermissions(userInfo),
  }
}
